import { z } from "zod";

export const loginSchema = z.object({
  identifier: z
    .string()
    .trim()
    .min(1, { message: "Username or email is required" })
    .refine(
      (value) => {
        if (value.includes("@")) {
          return z.string().email().safeParse(value).success;
        }
        return true;
      },
      { message: "Invalid email address" }
    ),
  password: z.string().min(1, { message: "Password is required" }),
});
